export default "__VITE_IMAGE_ASSET__cb689b6c__";